import ActionTypes from '../constants/ActionTypes';

const fetchEmployeePlans = (pointSystemId) => ({
  type: ActionTypes.EMPLOYEE_PLANS_FETCH,
  payload: {
    pointSystemId,
  },
});

fetchEmployeePlans.success = (pointSystemId, items) => ({
  type: ActionTypes.EMPLOYEE_PLANS_FETCH__SUCCESS,
  payload: {
    pointSystemId,
    items,
  },
});

fetchEmployeePlans.failure = (pointSystemId, error) => ({
  type: ActionTypes.EMPLOYEE_PLANS_FETCH__FAILURE,
  payload: {
    pointSystemId,
    error,
  },
});

const createEmployeePlan = (pointSystemId) => ({
  type: ActionTypes.EMPLOYEE_PLAN_CREATE,
  payload: {
    pointSystemId,
  },
});

createEmployeePlan.success = (item) => ({
  type: ActionTypes.EMPLOYEE_PLAN_CREATE__SUCCESS,
  payload: {
    item,
  },
});

createEmployeePlan.failure = (pointSystemId, error) => ({
  type: ActionTypes.EMPLOYEE_PLAN_CREATE__FAILURE,
  payload: {
    pointSystemId,
    error,
  },
});

const updateEmployeePlan = (id, data) => ({
  type: ActionTypes.EMPLOYEE_PLAN_UPDATE,
  payload: {
    id,
    data,
  },
});

updateEmployeePlan.success = (item) => ({
  type: ActionTypes.EMPLOYEE_PLAN_UPDATE__SUCCESS,
  payload: {
    item,
  },
});

updateEmployeePlan.failure = (id, error) => ({
  type: ActionTypes.EMPLOYEE_PLAN_UPDATE__FAILURE,
  payload: {
    id,
    error,
  },
});

const deleteEmployeePlan = (id) => ({
  type: ActionTypes.EMPLOYEE_PLAN_DELETE,
  payload: {
    id,
  },
});

deleteEmployeePlan.success = (item) => ({
  type: ActionTypes.EMPLOYEE_PLAN_DELETE__SUCCESS,
  payload: {
    item,
  },
});

deleteEmployeePlan.failure = (id, error) => ({
  type: ActionTypes.EMPLOYEE_PLAN_DELETE__FAILURE,
  payload: {
    id,
    error,
  },
});

export default {
  fetchEmployeePlans,
  createEmployeePlan,
  updateEmployeePlan,
  deleteEmployeePlan,
};

